<template>
  <Component
    :is="maxSmall ? Drawer : Dialog"
    @update:open="handleUpdateOpen"
    background="white"
    showFooter
    v-bind="maxSmall ? {} : { size: 'full', side: 'default' }"
    :teleport="maxSmall"
  >
    <slot />
    <template #header>
      <ProfileEmailHeader ref="header" />
    </template>
    <template #content>
      <ProfileEmailFields
        v-if="content === 'fields'"
        v-model:email="form.email"
        v-model:new_email="form.new_email"
        v-model:new_email_confirmation="form.new_email_confirmation"
        :errors="errors"
      />
      <ProfileEmailVerify
        v-if="content === 'verify'"
        :email="user.pending_email"
      />
    </template>
    <template #footer>
      <ProfileEmailFooter
        :content="content"
        :disablePrimary="disablePrimary"
        :busy="busy"
        @primaryAction="handlePrimaryAction"
        @secondaryAction="handleSecondaryAction"
      />
    </template>
  </Component>
</template>

<script setup>
import { computed, ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import { Dialog } from "@/SharedComponents/Dialog";
import { Drawer } from "@/SharedComponents/Drawer";
import {
  ProfileEmailFields,
  ProfileEmailFooter,
  ProfileEmailHeader,
  ProfileEmailVerify,
} from "@/SharedComponents/Profile/Dialogs/Email/Partials";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

const emit = defineEmits(["changeEmail", "resendEmail", "clearErrors"]);

const header = ref(null);
const content = ref("fields");

const props = defineProps({
  user: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  busy: { type: Boolean, required: false },
});

const form = useForm({
  email: props.user.email,
  new_email: "",
  new_email_confirmation: "",
});

const disablePrimary = computed(() => {
  if (content.value !== "fields") {
    return false;
  }
  if (Object.keys(props.errors).length) {
    return !form.isDirty;
  }
  return form.new_email === "" || form.new_email_confirmation === "";
});

function handleUpdateOpen(open) {
  if (open) {
    content.value = props.user.pending_email ? "verify" : "fields";
    form.defaults({
      new_email: "",
      new_email_confirmation: "",
    });
    form.reset();
    emit("clearErrors");
  }
}

function handlePrimaryAction() {
  emit("clearErrors");
  if (content.value === "fields") {
    form.defaults();
    emit("changeEmail", { form, onSuccess: () => (content.value = "verify") });
  } else {
    emit("resendEmail");
    header.value?.close();
  }
}

function handleSecondaryAction() {
  if (content.value === "fields") {
    header.value?.close();
  } else {
    content.value = "fields";
  }
}
</script>
